export const GRAPHQL_URL = `${window.ENV.HTTP_URL}/ota/graphql`
// export const GRAPHQL_URL = 'http://localhost:4001/graphql'
